// V4-FRONT-ANY-USAGE batch 5 2026-05-28
import { Save, RotateCcw, History } from 'lucide-react';
import { AnimatedIconButton } from '../../common/AnimatedIconButton';
import type { Mode } from '../tabs/PositioningTab';
import type { TranslationKeys } from '../../../i18n/fr';

interface PositioningToolbarProps {
  mode: Mode;
  setMode: (mode: Mode) => void;
  hasUnsavedChanges: boolean;
  positioningContext: string;
  setEditedPrompt: (value: string) => void;
  setHasUnsavedChanges: (value: boolean) => void;
  onSave: () => void;
  isSaving?: boolean;
  t: TranslationKeys;
  readOnly?: boolean;
}

/**
 * Barre d'outils du positionnement (historique, annuler, enregistrer)
 * Extrait de PositioningTab pour améliorer la maintenabilité
 */
export function PositioningToolbar({
  mode,
  setMode,
  hasUnsavedChanges,
  positioningContext,
  setEditedPrompt,
  setHasUnsavedChanges,
  onSave,
  isSaving = false,
  t,
  readOnly = false,
}: PositioningToolbarProps) {
  return (
    <div className="flex items-center gap-2 p-3 border-b" style={{ borderColor: 'var(--color-border)' }}>
      {/* Spacer */}
      <div className="flex-1" />

      {/* Cancel button - show if there are unsaved changes */}
      {!readOnly && hasUnsavedChanges && (
        <AnimatedIconButton
          icon={RotateCcw}
          label={t.common?.cancel || "Annuler"}
          onClick={() => {
            setEditedPrompt(positioningContext);
            setHasUnsavedChanges(false);
          }}
          variant="secondary"
          size="default"
          disabled={isSaving}
        />
      )}

      {/* Save button - only show if there are unsaved changes */}
      {!readOnly && hasUnsavedChanges && (
        <AnimatedIconButton
          icon={Save}
          label={t.positioning?.save || "Enregistrer"}
          onClick={onSave}
          variant="success"
          size="default"
          loading={isSaving}
          disabled={isSaving}
        />
      )}
      
      {/* History - Conservé pour récupérer les anciennes versions */}
      <AnimatedIconButton
        icon={History}
        label={t.positioning?.history || "Historique"}
        onClick={() => setMode(mode === 'history' ? 'text' : 'history')}
        variant={mode === 'history' ? 'default' : 'secondary'}
        size="default"
      />
    </div>
  );
}
